module.exports = "<chariot-connect id=\"chariot\" cid=\"{{$ctrl.connectId}}\"></chariot-connect>\n"